// extracted by mini-css-extract-plugin
export default {"root":"Sidebar__root___nBNRB","stickyTop":"Sidebar__stickyTop___F9xBo","stickyBottom":"Sidebar__stickyBottom___vrK9m"};